<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="countryList">
          <div class="country">
              <span>水库水情报表：</span>
          </div>
          <div class="country" v-for="(item,index) in rainstatis" :key="index" @click="navcheck(item,index,item.type)">
              <span :class="{'countryon':index==choosed}">{{item.name}}</span>
          </div>
      </div>
      <component :is="activeComponent"></component>
    </div>
  </div>
</template>
<script>
import TotalStorageLargeAndMediums from './largemidTotal'
import ReservoirAnalysisTable from './analysisTable'
import ReservoirWaterLevelStatistics from './waterLevelStatistics'
import ReservoirWaterLevelProcess from './waterLevelProcess'
export default {
  name: 'MonitoringCenter',
  components: {
    TotalStorageLargeAndMediums,
    ReservoirAnalysisTable,
    ReservoirWaterLevelStatistics,
    ReservoirWaterLevelProcess
  },
  data () {
    return {
      activeComponent: 'ReservoirWaterLevelStatistics',
      rainstatis: [
        // { name: '水库动态蓄水', type: 'DynamicWaterStorage' },
        { name: '水库时段水位统计', type: 'ReservoirWaterLevelStatistics' },
        { name: '水库水位过程', type: 'ReservoirWaterLevelProcess' }
        // { name: '大中型水库总蓄水量', type: 'TotalStorageLargeAndMediums' },
        // { name: '水库蓄水能力分析表', type: 'ReservoirAnalysisTable' }
      ],
      choosed: 0
    }
  },
  computed: {
  },
  methods: {
    navcheck: function (item, index, type) {
      this.choosed = index
      // console.log(type)
      this.activeComponent = type
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
